import {Component, inject, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Select} from '@core/components';
import {ModalService} from '@core/services';

export interface EmployeeFiltersValue {
  groupId: string | number | '';
  status: string;
  accessStatus: string;
}

@Component({
  selector: 'core-employee-filters',
  standalone: true,
  imports: [
    FormsModule,
    Select
  ],
  templateUrl: './employee-filters.html',
  styleUrl: './employee-filters.scss',
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 1.25rem;padding: 0 1.5rem 1.5rem'
  }
})
export class EmployeeFilters {
  @Input() filters: EmployeeFiltersValue = {
    groupId: '',
    status: '',
    accessStatus: ''
  };
  @Input() groupOptions: {label: string; value: string | number}[] = [];
  @Input() statusOptions: {label: string; value: string}[] = [];
  @Input() accessOptions: {label: string; value: string}[] = [];
  @Input() isLoadingOptions = false;

  private readonly modal = inject(ModalService);

  get isBusy() {
    return this.isLoadingOptions;
  }

  apply() {
    if (this.isBusy) return;
    this.modal.closeTop({...this.filters});
  }

  clear() {
    if (this.isBusy) return;
    this.modal.closeTop({
      groupId: '',
      status: '',
      accessStatus: ''
    } satisfies EmployeeFiltersValue);
  }

  close() {
    this.modal.closeTop(null);
  }
}
